import React, {
  FunctionComponent,
  useContext,
  useEffect,
  useState,
} from "react";
import PageProps from "../../models/PageProps.interface";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";

//Component Import
import LeftMenu from "../../components/leftMenu/leftMenu.component";
import TopNav from "../../components/topNav/topNav.component";
import Footer from "../../components/footer/footer.component";

//Css
import "../myWallet/myWallet.screen.style.css";
import TransactionService from "../../services/transaction/transaction.service";
import { ToastContext } from "../../context/toast.context";

//Icons Import
import { ToastSeverity } from "../../constants/toastSeverity.contants";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import UserService from "../../services/user/user.service";
import PlayGameService from "../../services/playGame/playGame.service";
import { IApiResponse } from "../../interface/Response/IApiResponse";
import { LoadingContext } from "../../context/loading.context";
import useMediaQuery from "@mui/material/useMediaQuery";
import { IDeclareResultsRequestModel } from "../../interface/Request/IDeclareResultsRequestModel";
import { INumberProbabilityReponseModal } from "../../interface/Response/INumberProbabilityReponseModal";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";

const columns: GridColDef[] = [
  { field: "rowNo", headerName: "Row No", flex: 1 },
  { field: "name", headerName: "Game", flex: 1 },
  { field: "optionName", headerName: "Type", flex: 1 },
  { field: "gameDate", headerName: "Game Date", flex: 1 },
  { field: "playedNumber", headerName: "Number", flex: 1 },
  { field: "playedCount", headerName: "No.of Users Played", flex: 1 },
  { field: "playedAmount", headerName: "Total Amount", flex: 1 },
  { field: "statusText", headerName: "Status", flex: 1 },
];

const NumberProbability: FunctionComponent<PageProps> = ({ title }) => {
  const theme = useTheme();
  const isSmScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { setLoading, isWebView } = useContext(LoadingContext);
  const [value, setValue] = React.useState<string>("1");
  const { setToastConfig, setOpen } = useContext(ToastContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const _transactionService = new TransactionService(dispatch);
  const _userService = new UserService(dispatch);
  const _playGameService = new PlayGameService(dispatch);
  const [declareResultsRequest, setDeclareResultsRequest] = useState<
    IDeclareResultsRequestModel
  >(location.state as IDeclareResultsRequestModel);

  const [allProbabilities, setAllProbabilities] = useState<
    INumberProbabilityReponseModal[]
  >([]);

  useEffect(() => {
    document.title = title;
    getAllProbabilities();
  }, []);

  const getAllProbabilities = async () => {
    try {
      if (declareResultsRequest) {
        setLoading(true);
        var response: IApiResponse = await _transactionService.getNumberProbability(
          declareResultsRequest.gameId,
          declareResultsRequest.gameHistoryId
        );

        if (!response.isSuccess) {
          setToastConfig(ToastSeverity.Error, response.message, true);
        } else {
          setAllProbabilities(
            response.response as INumberProbabilityReponseModal[]
          );
        }
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  function Row(props: {
    row: INumberProbabilityReponseModal;
    rowNumber: number;
  }) {
    const { row, rowNumber } = props;
    return (
      <React.Fragment>
        <TableRow key={row.rowNo} sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell key={"rowNo" + row.rowNo} data-label="Row No">
            {row.rowNo}
          </TableCell>
          <TableCell key={"name" + row.rowNo} data-label="Game">
            {row.name}
          </TableCell>
          <TableCell key={"optionName" + row.rowNo} data-label="Type">
            {row.optionName}
          </TableCell>
          <TableCell key={"gameDate" + row.rowNo} data-label="Game Date">
            {row.gameDate}
          </TableCell>
          <TableCell key={"playedNumber" + row.rowNo} data-label="Number">
            {row.playedNumber}
          </TableCell>
          <TableCell
            key={"playedCount" + row.rowNo}
            data-label="No.of Users Played"
          >
            {row.playedCount}
          </TableCell>
          <TableCell key={"playedAmount" + row.rowNo} data-label="Total Amount">
            {row.playedAmount}
          </TableCell>
          <TableCell key={"statusText" + row.rowNo} data-label="Status">
            {row.statusText}
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <Box className="pageMain">
      <Box className="pageLeft">
        <LeftMenu />
      </Box>
      <Box className="pageRight">
        <Box className="pageHead">
          <TopNav title={title.split("|")[1].trim()} />
        </Box>
        <Box className="pageView">
          <Box className="pageViewBody commonScroll">
            {isSmScreen ? (
              <Box>
                <TableContainer
                  component={Paper}
                  className="commonTable responsiveTable"
                >
                  <Table aria-label="collapsible table">
                    <TableHead>
                      <TableRow>
                        <TableCell
                          width={60}
                          key={0}
                          variant="head"
                          sx={{
                            backgroundColor: "background.paper",
                          }}
                        >
                          {"S.No"}
                        </TableCell>
                        {columns.map((column, index) => (
                          <TableCell
                            key={"head" + (index + 1)}
                            variant="head"
                            sx={{
                              backgroundColor: "background.paper",
                              flex: 1,
                            }}
                          >
                            {column.headerName}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {allProbabilities
                        // .filter((x) => x.appId.includes(searchText))
                        .map((row, index) => (
                          <Row row={row} rowNumber={index + 1} />
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            ) : (
              <DataGrid
                getRowId={(row) => row.rowNo}
                rows={allProbabilities}
                columns={columns}
                slots={{
                  toolbar: GridToolbar,
                }}
                pagination
                paginationMode="client"
                rowCount={allProbabilities.length}
              />
            )}
          </Box>

          <Box className="pageViewFooter">
            <Footer />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default NumberProbability;
